import { APP_DOMAIN_REGEX } from 'shared-worker-versioning/embed-utility/constants/appDomainRegex';
export function getAppDomain(hostname = window.location.hostname) {
  const domain = hostname.toLowerCase();
  return {
    isAppDomain: APP_DOMAIN_REGEX.test(domain),
    domain
  };
}